import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { CustomerAdminPaginationApi } from '../_models/customer';
import { PaginationParams } from '../_models/generic';
import { HttpClient } from '../_services/global-http.service';
import { Utilities } from '../_utilities/Utilities';

@Injectable()
export class CustomersService {
  constructor(private http: HttpClient) { }

  data: any;

  getCustomers() {
    this.data = this.http.get('/api/customers/');
    return this.data;
  }
  getCustomersMinimal() {
    this.data = this.http.get('/api/customers_minimal/');
    return this.data;
  }

  findAdminCustomers(params: PaginationParams): Observable<CustomerAdminPaginationApi> {
    const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<CustomerAdminPaginationApi>('/api/administration/customers/', { params: _params }
    ).pipe(
      map(res => res)
    );
  }
  // getAdminCustomers(params: PaginationParams) {
  //   return this.http.get('/api/administration/customers/', {params: params});
  // }

  getCustomer(cid) {
    this.data = this.http.get('/api/customer/' + cid + '/');
    return this.data;
  }

  postAddCustomer(newCustomer: any) {
    const apiAddNewCustomer = '/api/customers/';
    this.data = this.http.post(apiAddNewCustomer, newCustomer);
    return this.data;
  }

  removeCustomers(id: any) {
    this.data = this.http.post('/api/customers_delete/', id);
    return this.data;
  }

  putUpdateCustomer(updateCustomer: any, id: number) {
    const apiUpdateCustomer = '/api/customer/' + id + '/';
    this.data = this.http.put(apiUpdateCustomer, updateCustomer);
    return this.data;
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/customers.service.ts